<div class="file-drop-area">
  <span class="fake-btn">Choose file</span>
  <span class="file-msg">{{currentFileUpload ? currentFileUpload.name : 'or drag and drop file here' }}</span>
  <input *ngIf = "fileType !== 'csv'" class="file-input" type="file" accept="image/png, image/jpeg">
  <input *ngIf = "fileType === 'csv'" class="file-input" type="file" accept=".csv">
</div>
<app-progress [progress]="progress"></app-progress>
